import React, { Component } from 'react';
import { Table, Button,Alert,Tag,Input,message } from 'antd';
import { Link } from "react-router-dom";
// import MaterialTable from 'material-table';
const { Search } = Input;
const queryString = require('query-string');

class GenTable extends Component {
    constructor(props) {
        super(props);
        this.state = {  filteredInfo: null,
            sortedInfo: null,
            searchvalue:'',
            filteredBranch:  [],
            columns : null,
            columnsData:null,
            dynamicData:null,
            filteredInfo:{
              branch:null,
              campus:null,
              section:null
            },
            filteredCampus:  [],
            filteredSection : [],
            selectedRowKeys: [] }
    }

    componentDidMount() {
        var parsed = queryString.parse(this.props.props.location.search);
        
        if(!parsed.Branch || parsed.Branch=='null'){
          parsed.Branch=null ||this.props.branch
        }

        if(parsed.Branch ){
          parsed.Branch=[parsed.Branch]
        }

        if(!parsed.Campus || parsed.Campus=='null'){
          parsed.Campus=null || this.props.campus
        }

        if(parsed.Campus){
          parsed.Campus=[parsed.Campus]
        }

        if(!parsed.Section || parsed.Section=='null'){
          parsed.Section=null || this.props.section
        }

        if(parsed.Section){
          parsed.Section=[parsed.Section]
        }

        if(parsed.Branch || parsed.Campus || parsed.Section ){
          this.setState({
                filteredBranch: [parsed.Branch],
                filteredCampus: [parsed.Campus],
                filteredSection: [parsed.Section],
                filteredInfo:  {branch : parsed.Branch, campus:parsed.Campus, section:parsed.Section}
          })
        }
        
      }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
          filteredBranch: filters.branch || [],
          filteredCampus: filters.campus || [],
          filteredSection : filters.section || [],
          filteredInfo: filters,
          sortedInfo: sorter,
        });
      };
    
      clearAll = () => {
        this.setState({
          filteredBranch:  [],
          filteredCampus:  [],
          filteredSection : [],
          filteredInfo: null,
          sortedInfo: null,
        });
      };
    
      setAgeSort = () => {
        this.setState({
          sortedInfo: {
            order: 'descend',
            columnKey: 'age',
          },
        });
      };

      onSelectChange = (selectedRowKeys, selectedRows) => {
        const selected = Array.prototype.map
          .call(selectedRows, function(item) {
            return item.email;
          })
          .join(",");
        this.setState({ selected });
        this.setState({ selectedRowKeys });
      };
    
      sendMail = () => {
        
        window.open(
          "mailto:" + this.state.selected,
          "name",
          "height=900,width=900"
        );
      };

    render() { 
        let { sortedInfo, filteredInfo,selectedRowKeys,filteredBranch, filteredCampus, filteredSection,columnsData,dynamicData } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            onSelect: this.onSelect
          };

          const columns = [
            {
              title: 'Personal Details',
             
              children: [
                {
                  title: 'Name',
                  dataIndex: 'displayname',
                  key: 'displayname',
                  sorter: (a, b) => a.displayname && a.displayname.localeCompare(b.displayname),
                  ellipsis: true,
                  width:100,
                  render: (text, row, index) => (
                    <Link style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:'180px'}} to={`/home/profile/${row.UID}`}>{text}</Link>
                  )
                },
                {
                    title: 'Campus',
                    dataIndex: 'campus',
                    key: 'campus',
                    filters: [{text: 'BVRIT',value: 'BVRIT'},{text: 'VIT',value: 'VIT'},{text: 'BVRITH',value: 'BVRITH'},{text: 'SVECW',value: 'SVECW'}],
                    filteredValue: filteredInfo.campus || null,
                    onFilter: (value, record) => record && record.campus && record.campus.match(new RegExp('^'+value+'$','g')),
                    
                    width: 120,
                  },
                  {
                    title: 'Branch',
                    dataIndex: 'branch',
                    key: 'branch',
                    filters: [{text: 'ECE',value: 'ECE'},{text: 'CSE',value: 'CSE'},{text: 'IT',value: 'IT'},{text: 'EIE',value: 'EIE'},{text: 'EEE',value: 'EEE'},{text: 'MECH',value: 'MECH'}],
                    filteredValue: filteredInfo.branch || null,
                    onFilter: (value, record) => record && record.branch && record.branch.match(new RegExp('^'+value+'$','g')),
                    width: 120,
                  },
                  {
                    title: 'Section',
                    dataIndex: 'section',
                    key: 'section',
                    filters: [{text: 'A',value: 'A'},{text: 'B',value: 'B'},{text: 'C',value: 'C'},{text: 'D',value: 'D'},{text: 'E',value: 'E'},{text: 'F',value: 'F'}],
                    filteredValue: filteredInfo.section || null,
                    onFilter: (value, record) =>  record && record.section && record.section.match(new RegExp('^'+value+'$','g')),
                    width: 120,
                  },
                  {
                    title: 'gradYear',
                    dataIndex: 'gradYear',
                    key: 'gradYear',
                    filters: [{text: '2019',value: '2019'},{text: '2020',value: '2020'},{text: '2021',value: '2021'},{text: '2022',value: '2022'},{text: '2023',value: '2023'},{text: '2024',value: '2024'},{text: '2025',value: '2025'}],
                    filteredValue: filteredInfo.gradYear || null,
                    onFilter: (value, record) =>  record && record.gradYear && record.gradYear.match(new RegExp('^'+value+'$','g')),
                    width: 120,
                  }
              ],
            },
            {
              title: <div style={{background:'rgb(137, 234, 172)',padding:'7px 23px',borderRadius:4}}><img src="https://www.hackerrank.com/wp-content/uploads/2018/07/hackerrank-favicon.png" style={{width:20,height:20}}></img> HackerRank</div>,
              children: [
                {
                  title: 'Username',
                  dataIndex: 'HackerRank.userName',
                  key: 'HackerRank.userName',
                  width: 120,
                  render: (text, row, index) => (
                  <>{text || text==0 ? <Tag color="purple"><a style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:'180px'}} target="_blank" href={"https://www.hackerrank.com/profile/"+text}>{text}</a></Tag> : <Tag color="volcano">NA</Tag>}</>
                  )
                 
                },
                {
                  title: 'Score in Data Structures [DS]',
                  dataIndex: 'HackerRank.dataStructures',
                  key: 'HackerRank.dataStructures',
                  width: 110,
                  sorter: (a, b) =>  (a.HackerRank && b.HackerRank && a.HackerRank.dataStructures && b.HackerRank.dataStructures) && a.HackerRank.dataStructures-b.HackerRank.dataStructures,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                },
                {
                  title: 'Score in Algorithms [Algo]',
                  dataIndex: 'HackerRank.algorithms',
                  key: 'HackerRank.algorithms',
                  width: 110,
                  sorter: (a, b) =>  (a.HackerRank && b.HackerRank && a.HackerRank.algorithms && b.HackerRank.algorithms) && a.HackerRank.algorithms-b.HackerRank.algorithms,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                },
                {
                  title: 'Score in Maths',
                  dataIndex: 'HackerRank.mathematics',
                  key: 'HackerRank.mathematics',
                  width: 110,
                  sorter: (a, b) =>  (a.HackerRank && b.HackerRank && a.HackerRank.mathematics && b.HackerRank.mathematics) && a.HackerRank.mathematics-b.HackerRank.mathematics,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                },
                {
                  title: 'Score [DS+Algo+Math]',
                  dataIndex: 'HackerRank.totalDsAlgo',
                  key: 'HackerRank.totalDsAlgo',
                  width: 110,
                  sorter: (a, b) =>  (a.HackerRank && b.HackerRank && a.HackerRank.totalDsAlgo && b.HackerRank.totalDsAlgo) && a.HackerRank.totalDsAlgo-b.HackerRank.totalDsAlgo,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                },
                {
                  title: 'Total Score [Easy+Medium+Hard]',
                  dataIndex: 'HackerRank.totalEMH',
                  key: 'HackerRank.totalEMH',
                  sorter: (a, b) =>  (a.HackerRank && b.HackerRank && a.HackerRank.totalEMH && b.HackerRank.totalEMH) && a.HackerRank.totalEMH-b.HackerRank.totalEMH,
                  width: 110,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                }
            
              ],
            },
            {
              title: <div style={{background:'rgb(165, 179, 232)',padding:'7px 23px',borderRadius:4}}><img src="https://static-fastly.hackerearth.com/static/hackerearth/images/logo/HE_identity.png" style={{width:20,height:20}}></img>HackerEarth</div>,
              children: [
                {
                  title: 'Username',
                  dataIndex: 'HackerEarth.userName',
                  key: 'HackerEarth.userName',
                  width: 120,
                  render: (text, row, index) => (
                    <>{text || text==0 ? <Tag color="purple"><a style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:'180px'}} target="_blank" href={"https://www.hackerearth.com/@"+text}>{text}</a></Tag> : <Tag color="volcano">NA</Tag>}</>
                    )

                },
                {
                  title: 'Score in Data Structures [DS]',
                  dataIndex: 'HackerEarth.dataStructures',
                  key: 'HackerEarth.dataStructures',
                  width: 110,
                  sorter: (a, b) =>  (a.HackerEarth && b.HackerEarth && a.HackerEarth.dataStructures && b.HackerEarth.dataStructures) && a.HackerEarth.dataStructures-b.HackerEarth.dataStructures,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                },
                {
                  title: 'Score in Algorithms [Algo]',
                  dataIndex: 'HackerEarth.algorithms',
                  key: 'HackerEarth.algorithms',
                  width: 110,
                  sorter: (a, b) =>  (a.HackerEarth && b.HackerEarth && a.HackerEarth.algorithms && b.HackerEarth.algorithms) && a.HackerEarth.algorithms-b.HackerEarth.algorithms,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                },
                {
                  title: 'Score in Maths',
                  dataIndex: 'HackerEarth.mathematics',
                  key: 'HackerEarth.mathematics',
                  width: 110,
                  sorter: (a, b) =>  (a.HackerEarth && b.HackerEarth && a.HackerEarth.mathematics && b.HackerEarth.mathematics) && a.HackerEarth.mathematics-b.HackerEarth.mathematics,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                },
                {
                  title: 'Score [DS+Algo+Math]',
                  dataIndex: 'HackerEarth.totalDsMathAlgo',
                  key: 'HackerEarth.totalDsMathAlgo',
                  width: 110,
                  sorter: (a, b) =>  (a.HackerEarth && b.HackerEarth && a.HackerEarth.totalDsMathAlgo && b.HackerEarth.totalDsMathAlgo) && a.HackerEarth.totalDsMathAlgo-b.HackerEarth.totalDsMathAlgo,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                },
                {
                  title: 'Total Score [Easy+Medium+Hard]',
                  dataIndex: 'HackerEarth.totalEMH',
                  key: 'HackerEarth.totalEMH',
                  sorter: (a, b) =>  (a.HackerEarth && b.HackerEarth && a.HackerEarth.totalEMH && b.HackerEarth.totalEMH) && a.HackerEarth.totalEMH-b.HackerEarth.totalEMH,
                  width: 110,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                }
            
              ],
            },
            {
              title:<div style={{background:'rgb(69, 208, 137)',padding:'7px 23px',borderRadius:4}}><img src="https://www.geeksforgeeks.org/favicon.ico" style={{width:20,height:20}}></img> GeeksForGeeks</div>,
              children: [
                {
                  title: 'Username',
                  dataIndex: 'GeeksForGeeks.userName',
                  key: 'HackerEarth.userName',
                  width: 50,
                  ellipsis:true,
                  render: (text, row, index) => (
                    <>{text || text==0 ? <Tag color="purple"><a style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:'180px'}} target="_blank" href={"https://auth.geeksforgeeks.org/user/"+text}>{text}</a></Tag> : <Tag color="volcano">NA</Tag>}</>
                    )
                },
                {
                  title: 'Score in Easy',
                  dataIndex: 'GeeksForGeeks.Easy',
                  key: 'GeeksForGeeks.Easy',
                  width: 110,
                  sorter: (a, b) =>  (a.GeeksForGeeks && b.GeeksForGeeks && a.GeeksForGeeks.Easy && b.GeeksForGeeks.Easy) && a.GeeksForGeeks.Easy-b.GeeksForGeeks.Easy,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                },
                {
                  title: 'Score in Medium',
                  dataIndex: 'GeeksForGeeks.Medium',
                  key: 'GeeksForGeeks.Medium',
                  width: 110,
                  sorter: (a, b) =>  (a.GeeksForGeeks && b.GeeksForGeeks && a.GeeksForGeeks.Medium && b.GeeksForGeeks.Medium) && a.GeeksForGeeks.Medium-b.GeeksForGeeks.Medium,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                },
                {
                  title: 'Score in Hard',
                  dataIndex: 'GeeksForGeeks.Hard',
                  key: 'GeeksForGeeks.Hard',
                  sorter: (a, b) =>  (a.GeeksForGeeks && b.GeeksForGeeks && a.GeeksForGeeks.Hard && b.GeeksForGeeks.Hard) && a.GeeksForGeeks.Hard-b.GeeksForGeeks.Hard,
                  width: 110,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                },
                {
                  title: 'Total Score [Easy+Medium+Hard+School+Basic]',
                  dataIndex: 'GeeksForGeeks.totalEMH',
                  key: 'GeeksForGeeks.totalEMH',
                  sorter: (a, b) =>  (a.GeeksForGeeks && b.GeeksForGeeks && a.GeeksForGeeks.totalEMH && b.GeeksForGeeks.totalEMH) && a.GeeksForGeeks.totalEMH-b.GeeksForGeeks.totalEMH,
                  width: 110,
                  render: (text, row, index) => (
                    <>{text || text==0 ? text : <Tag color="volcano">NA</Tag>}</>
                  )
                }
            
              ],
            },
            {
                  title: 'Overall Score',
                  dataIndex: 'totalScore',
                  key: 'totalScore',
                  width: 100,
                  fixed:'right',
                  defaultSortOrder: 'descend',
                  sorter:(row,rowTwo)=>{
                    
                    var a =0;
                    var b=0;
                    if(row.GeeksForGeeks){
                      a=  a+row.GeeksForGeeks.totalEMH;
                    }
                    if(row.HackerEarth){
                      a=a+row.HackerEarth.totalDsMathAlgo
                    }
                    if(row.HackerRank){
                      a=a+row.HackerRank.totalDsAlgo
                    }
                    if(rowTwo.GeeksForGeeks){
                      b=  b+rowTwo.GeeksForGeeks.totalEMH;
                    }
                    if(rowTwo.HackerEarth){
                      b=b+rowTwo.HackerEarth.totalDsMathAlgo
                    }
                    if(rowTwo.HackerRank){
                      b=b+rowTwo.HackerRank.totalDsAlgo
                    }

                    return a-b;
                  },
                  render: (text, row, index) => {
                      var a =0;
                      if(row.GeeksForGeeks){
                        a=  a+row.GeeksForGeeks.totalEMH;
                      }
                      if(row.HackerEarth){
                        a=a+row.HackerEarth.totalDsMathAlgo
                      }
                      if(row.HackerRank){
                        a=a+row.HackerRank.totalDsAlgo
                      }
                      return a;
                    }
            }
           ];
          
    const hasSelected = selectedRowKeys.length > 0;
    return (
      <div>
        <div style={{ marginBottom: 16 }}>
                <Button
                  onClick={this.sendMail}
                  type="primary"
                  disabled={!hasSelected}
                >
                  Send Mail
                </Button>
                <span style={{ marginLeft: 8 }}>
                  {hasSelected
                    ? `Selected ${selectedRowKeys.length} items`
                    : ""}
                </span>
              </div>

              {filteredBranch.length > 0 ||filteredCampus.length>0 || filteredSection.length>0 ? (
                <>
                  <Alert
                    message={`Filtered by ${filteredCampus.toString()} Campus | ${filteredBranch.toString()} Branch | ${filteredSection.toString()} Section`}
                    type="info"
                    showIcon
                  />{" "}
                  <Button
                    type="primary"
                    icon="close"
                    onClick={this.clearAll}
                    style={{ marginBottom: 25, marginTop: 10 }}
                  >
                    Clear Filters
                  </Button>{" "}
                </>
              ) : null}

       {columns && this.props.data ?  

       <Table 
       pagination={{showSizeChanger:true}}
       size="middle"
       title={() => <><Search
         placeholder="Search in table"
         enterButton="Search"
         size="large"
         style={{width:'85%',marginRight:10}}
         allowClear 
         onSearch={value => this.setState({searchvalue:value})}
       /><Button style={{background:'#001529',color:'white'}} onClick={()=>message.info('Feature not yet available. Coming soon')}  type="dashed" icon="download" size="large">Export to Excel</Button></>
     }
      scroll={{ x: true }} bordered rowSelection={rowSelection}  rowKey={this.props.data.UID} columns={columns} 
      dataSource={this.props.data.filter(data=> Object.keys(data).filter(key => ((data[key]).toString().toUpperCase()).includes((this.state.searchvalue).toUpperCase())).length > 0 ? true: false)}
      onChange={this.handleChange}  />  
    
    : null}
      </div>
    );
    }
}
 
export default GenTable;